import DeclarationOfEmployment from "./DeclarationOfEmployment";
export default DeclarationOfEmployment;
